import type { ButtonHTMLAttributes } from 'react';
import { Icono, type NombreIcono } from './Icono';
import { Girador } from './Girador';

export type VarianteBoton = 'primario' | 'secundario' | 'fantasma' | 'peligro' | 'icono';
export type TamanoBoton = 'chico' | 'mediano' | 'grande';

interface PropsBoton extends ButtonHTMLAttributes<HTMLButtonElement> {
  variante?: VarianteBoton;
  tamano?: TamanoBoton;
  icono?: NombreIcono;
  iconoDerecha?: NombreIcono;
  cargando?: boolean;
  anchoCompleto?: boolean;
}

const LADO_ICONO: Record<TamanoBoton, number> = { chico: 14, mediano: 16, grande: 18 };

export function Boton({
  variante = 'primario',
  tamano = 'mediano',
  icono,
  iconoDerecha,
  cargando = false,
  anchoCompleto = false,
  type = 'button',
  disabled,
  className,
  children,
  ...resto
}: PropsBoton) {
  const lado = LADO_ICONO[tamano];
  const clases = [
    'boton',
    `boton--${variante}`,
    `boton--${tamano}`,
    anchoCompleto && 'boton--ancho',
    className,
  ].filter(Boolean).join(' ');

  return (
    <button
      type={type}
      className={clases}
      disabled={disabled || cargando}
      aria-busy={cargando || undefined}
      {...resto}
    >
      {cargando ? <Girador tamano={lado} /> : icono && <Icono nombre={icono} tamano={lado} />}
      {variante !== 'icono' && children}
      {iconoDerecha && !cargando && <Icono nombre={iconoDerecha} tamano={lado} />}
    </button>
  );
}
